module.exports = __webpack_public_path__ + "img/1731378730112  2段下 (1).63c5d423.png";